
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnrollView } from '../../_models/EnrollView';
import { environment } from 'src/environments/environment';



const httpOptions = {
  headers: new HttpHeaders({
    Authorization: 'Bearer ' + localStorage.getItem('token')
  })
}

let httpHeaders = new HttpHeaders()
  .set('Authorization', 'Bearer ' + localStorage.getItem('token'))
  .set('Content-Type', 'application/json');
let options = {
  headers: httpHeaders
};


@Injectable({
  providedIn: 'root'
})
export class EnrollService {
  private baseUrl = environment.apiUrl + 'Enroll/';
  constructor(private http: HttpClient) { }
  GetOverAllDeviceStatus(Datetime:any):  Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.baseUrl + 'RealTimeEnroll?Time='+Datetime, {
      headers: httpHeaders,
      observe: 'response'
    }
    );
  }

 
}
